__turbopack_context__.v({
  "active": "_footer-module-scss-module__P6O3OG__active",
  "arrow": "_footer-module-scss-module__P6O3OG__arrow",
  "footerSection": "_footer-module-scss-module__P6O3OG__footerSection",
  "language-dropdown": "_footer-module-scss-module__P6O3OG__language-dropdown",
  "language-option": "_footer-module-scss-module__P6O3OG__language-option",
  "open": "_footer-module-scss-module__P6O3OG__open",
  "slideDown": "_footer-module-scss-module__P6O3OG__slideDown",
});
